import React, { useState } from 'react';
import HistorialService from '../services/historiales';
import { notificationSystem } from '../utils/notifications';

function Antecedentes({ antecedentes, paciente_id, onRefresh }) {
  const [editando, setEditando] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    antecedentes_familiares: antecedentes?.antecedentes_familiares || '',
    antecedentes_personales: antecedentes?.antecedentes_personales || '',
    antecedentes_medicos: antecedentes?.antecedentes_medicos || '',
    medicamentos_actuales: antecedentes?.medicamentos_actuales || '',
    alergias: antecedentes?.alergias || '',
    habitos: antecedentes?.habitos || '',
    situacion_laboral: antecedentes?.situacion_laboral || '',
    situacion_familiar: antecedentes?.situacion_familiar || ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await HistorialService.actualizarAntecedentes(paciente_id, formData);
      notificationSystem.success('Antecedentes guardados');
      setEditando(false);
      onRefresh();
    } catch (error) {
      console.error('Error:', error);
      notificationSystem.error('Error al guardar antecedentes');
    } finally {
      setLoading(false);
    }
  };

  const seccionesAntecedentes = [
    { key: 'antecedentes_familiares', label: '👨‍👩‍👧‍👦 Antecedentes Familiares' },
    { key: 'antecedentes_personales', label: '👤 Antecedentes Personales' },
    { key: 'antecedentes_medicos', label: '🏥 Antecedentes Médicos' },
    { key: 'medicamentos_actuales', label: '💊 Medicamentos Actuales' },
    { key: 'alergias', label: '⚠️ Alergias' },
    { key: 'habitos', label: '🚴 Hábitos' },
    { key: 'situacion_laboral', label: '💼 Situación Laboral' },
    { key: 'situacion_familiar', label: '👪 Situación Familiar' }
  ];

  if (editando) {
    return (
      <div className="antecedentes-section">
        <h3>Editar Antecedentes</h3>
        <form onSubmit={handleSubmit} className="formulario">
          {seccionesAntecedentes.map(seccion => (
            <div key={seccion.key} className="antecedente-campo">
              <label>{seccion.label}</label>
              <textarea 
                name={seccion.key}
                value={formData[seccion.key]}
                onChange={handleChange}
                rows="4"
                placeholder={`Ingrese ${seccion.label.toLowerCase()}`}
              />
            </div>
          ))}

          <div className="form-buttons">
            <button type="submit" className="btn-guardar" disabled={loading}>
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
            <button 
              type="button" 
              className="btn-cancelar" 
              onClick={() => setEditando(false)}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    );
  }

  const tieneAntecedentes = Object.values(formData).some(value => value.trim() !== '');

  return (
    <div className="antecedentes-section">
      <button 
        className="btn-agregar" 
        onClick={() => setEditando(true)}
      >
        {tieneAntecedentes ? '✏️ Editar Antecedentes' : '+ Agregar Antecedentes'}
      </button>

      {!tieneAntecedentes ? (
        <div className="no-data-section">
          <p className="no-data">No hay antecedentes registrados</p>
        </div>
      ) : (
        <div className="antecedentes-grid">
          {seccionesAntecedentes.map(seccion => (
            formData[seccion.key].trim() !== '' && (
              <div key={seccion.key} className="antecedente-card">
                <div className="antecedente-header">
                  <h4>{seccion.label}</h4>
                </div>
                <p className="antecedente-contenido">{formData[seccion.key]}</p>
              </div>
            )
          ))}
        </div>
      )}
    </div>
  );
}

export default Antecedentes;
